
import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import JsonRenderer from './JsonRenderer';
import jsonData from './data.json';
import questions from './questions.json';
import './App.css'; // Import your CSS file for styling

const App = () => {
  const [showFilters, setShowFilters] = useState(true);
  const [loadingStep, setLoadingStep] = useState(0);
  const [jsonQuestions, setjsonQuestions] = useState(null);

  useEffect(() => {
    // Set the JSON data from the imported file
    console.log(questions);
    setjsonQuestions(questions);
  }, []);


  const handleStartAnalysis = () => {
    setLoadingStep(1); // Start the loading process by showing "Analysing"
    setTimeout(() => {
      setLoadingStep(2); // Move to the next step after 1 second ("Grouping...")
      setTimeout(() => {
        setLoadingStep(3); // Move to the next step after 1 second ("Formatting...")
        setTimeout(() => {
          setLoadingStep(0);
          setShowFilters(false); // Hide the filter page after 1 second ("JSON Renderer" page)
        }, 1000);
      }, 1000);
    }, 1000);
  };

  return (
    <div className="app-container">
      {showFilters ? (
        <div className="filter-page">
          <h1>Welcome to the AI Powered Q&A</h1>
          <Button
            variant="outlined"
            size="large"
            onClick={handleStartAnalysis}
            disabled={loadingStep > 0}
          >
              {loadingStep === 0
                ? 'Make Q&A Easy'
                : loadingStep === 1
                ? 'Analysing...'
                : loadingStep === 2
                ? 'Grouping...'
                : 'Formatting...'}
          </Button>
          {jsonQuestions && jsonQuestions.questions && (
            <div className="initial-questions">
              <h2>All Questions ({jsonQuestions.questions.length})</h2>
              {Object.keys(jsonQuestions).map((key, index) => (
                <div key={index}>
                  <ol>
                    {jsonQuestions.questions.map((question, questionIndex) => (
                      <li key={questionIndex}>{question}</li>
                    ))}
                  </ol>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <>
          {loadingStep > 0 && (
            <div className="loading-text">
              {loadingStep === 1
                ? 'Analysing...'
                : loadingStep === 2
                ? 'Grouping...'
                : 'Formatting...'}
            </div>
          )}
          {loadingStep === 0 && (
            <>
            <center>
              <header className="app-header">AI Powered Q&A</header>
            </center>
              <JsonRenderer data={jsonData} />
            </>
          )}
        </>
      )}
      <div className="footer">
        [POC] Developed by Sikander Khan &copy; {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default App;